import { LLMModel } from "@/utils/config/elevenlabs";

const PROVIDER_ICON_SRC: Record<LLMModel["provider"], string> = {
  OpenAI: "/icons/llm-providers/openai.svg",
  Anthropic: "/icons/llm-providers/anthropic.svg",
  Google: "/icons/llm-providers/google.svg",
  xAI: "/icons/llm-providers/xai.svg",
  Alibaba: "/icons/llm-providers/alibaba.svg",
  ElevenLabs: "/icons/llm-providers/elevenlabs.svg",
};

interface ProviderIconProps {
  provider: LLMModel["provider"];
  className?: string;
}

export const ProviderIcon = ({ provider, className = "h-4 w-4" }: ProviderIconProps) => (
  <img src={PROVIDER_ICON_SRC[provider]} alt={provider} title={provider} className={className} />
);
